module.exports = __webpack_public_path__ + "img/logo.4cc565f5.png";